// extracted by mini-css-extract-plugin
export default {"button":"style_button__-ayKL","paypal":"style_paypal__zvDow","default":"style_default__yMJKI"};